import { type Reference } from "@apollo/client"
import { uniqueBy } from "@digits-shared/helpers/filters"

export type ExistsFn<TData = object> = (list: TData[], elem: TData) => boolean

export function reducerAppend<TData = object>(exists: ExistsFn<TData> | undefined) {
  return (list: TData[], newElem: TData) => {
    const existsInList = exists ? exists(list, newElem) : false

    if (!existsInList) list.push(newElem)
    return list
  }
}

export function reducerPrepend<TData = object>(exists: ExistsFn<TData> | undefined) {
  return (list: TData[], newElem: TData) => {
    const existsInList = exists ? exists(list, newElem) : false

    if (!existsInList) list.unshift(newElem)
    return list
  }
}

export function mergeArraysBy<TData>(selector: (item: TData) => unknown) {
  return (existing: TData[] = [], incoming: TData[] = []) =>
    [...incoming, ...existing].filter(uniqueBy(selector))
}

// oxlint-disable-next-line no-underscore-dangle
export const mergeArrays = mergeArraysBy((r: Reference) => r.__ref)
